'use client'

import { useState, type ReactNode } from 'react'
import { CarouselBlockShell } from '@/components/ui/carousel-block-shell'
import { CarouselContent } from '@/components/ui/carousel'
import type { CarouselApi } from '@/components/ui/carousel'
import { useCarouselCurrentIndex } from '@/components/ui/use-carousel-current-index'
import type { Icon } from '@/payload-types'

export function RowCarouselClient({
  iconLeft,
  iconRight,
  showIndicators = true,
  count,
  children,
}: {
  iconLeft?: string | Icon | null
  iconRight?: string | Icon | null
  showIndicators?: boolean | null
  count: number
  children: ReactNode
}) {
  const [api, setApi] = useState<CarouselApi>()
  const current = useCarouselCurrentIndex(api, count)

  return (
    <CarouselBlockShell
      ariaLabel="Content carousel"
      setApi={setApi}
      opts={{ align: 'center', containScroll: false, loop: count > 1 }}
      iconLeft={iconLeft}
      iconRight={iconRight}
      count={count}
      current={current}
      onSelect={(index) => api?.scrollTo(index)}
      showIndicators={showIndicators !== false}
    >
      <CarouselContent className="ml-0">
        {children}
      </CarouselContent>
    </CarouselBlockShell>
  )
}
